/* ============================================================
   カード（コレクション/おすすめ等）のカラー別 画像切替
   ------------------------------------------------------------
   ねらい：
   - PDP（variant-media-filter.js）と同じ「画像の alt のカラー名」で
     カード画像を出し分ける。判定基準を PDP と揃える。
   - スワッチUIは Globo Color Swatch を利用。Globo のスワッチ
     （input[value="カラー名"] / label）のクリック・ホバー・選択に
     連動して、カードのメイン画像を alt 一致の画像へ差し替える。

   仕組み：
   - Liquid が各カードに color→画像 の対応を JSON で出力
     （script.card-color-media-data）。キーは alt を小文字化したカラー名。
   - data-card-initial-color に初期表示色（最初に購入可能なバリアントの色）。
   - Globo は非同期でスワッチを注入するため、イベントは document への
     委譲で拾う。初期表示は Liquid の初期色で即時に合わせる。
   ============================================================ */
(function () {
  'use strict';

  var DATA_SEL = '[data-card-color-media]';

  function norm(s) {
    return (s == null ? '' : String(s)).trim().toLowerCase();
  }

  function readMap(mediaEl) {
    if (mediaEl._ccmMap) return mediaEl._ccmMap;
    var script = mediaEl.querySelector('.card-color-media-data');
    var map = {};
    if (script) {
      try {
        var raw = JSON.parse(script.textContent) || {};
        Object.keys(raw).forEach(function (k) {
          map[norm(k)] = raw[k];
        });
      } catch (e) {}
    }
    mediaEl._ccmMap = map;
    return map;
  }

  // カード内のカラー対応メディア要素を返す（無ければ null）
  function mediaElOf(node) {
    var card = node.closest ? node.closest('.card-wrapper') : null;
    if (!card) return null;
    return card.querySelector(DATA_SEL);
  }

  // カードのメイン画像を取得（Globo が img を差し替えて data 属性が
  // 消えるケースに備え、フォールバックで .media の先頭 img も拾う）
  function primaryImg(mediaEl) {
    return (
      mediaEl.querySelector('[data-card-color-primary]') ||
      mediaEl.querySelector('.media img')
    );
  }

  function writeImg(mediaEl, entry) {
    var img = primaryImg(mediaEl);
    if (!img) return false;
    if (img.getAttribute('src') === entry.src) return true; // 既に一致
    mediaEl._ccmWriting = true; // 自分の変更で監視ループしないための目印
    img.setAttribute('src', entry.src);
    if (entry.srcset) img.setAttribute('srcset', entry.srcset);
    if (entry.alt != null) img.setAttribute('alt', entry.alt);
    mediaEl._ccmWriting = false;
    return true;
  }

  function applyColor(mediaEl, color) {
    color = norm(color);
    if (!color) return;
    var map = readMap(mediaEl);
    var entry = map[color];
    if (!entry || !entry.src) return; // その色の画像が無ければ何もしない
    mediaEl._ccmCurrent = color;
    mediaEl._ccmEntry = entry;
    writeImg(mediaEl, entry);
    ensureGuard(mediaEl); // Globo の上書きに備えて監視を張る
  }

  // Globo が画像を差し替え直しても、選択中カラーの画像へ復帰させる監視。
  // 自分の変更（_ccmWriting）は無視し、無限ループを防ぐ。
  function ensureGuard(mediaEl) {
    if (mediaEl._ccmGuard || !('MutationObserver' in window)) return;
    var target = mediaEl.querySelector('.media') || mediaEl;
    var obs = new MutationObserver(function () {
      if (mediaEl._ccmWriting || !mediaEl._ccmEntry) return;
      var img = primaryImg(mediaEl);
      if (img && img.getAttribute('src') !== mediaEl._ccmEntry.src) {
        writeImg(mediaEl, mediaEl._ccmEntry);
      }
    });
    obs.observe(target, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset'] });
    mediaEl._ccmGuard = obs;
  }

  // Globo のスワッチ要素からカラー名を推定する
  function colorFromTarget(t) {
    if (!t || !t.closest) return null;
    // ラジオ本体
    var input = t.closest('.swatches-options')
      ? t.closest('.swatches-options').querySelector('input[type="radio"]')
      : null;
    if (input && input.value) return input.value;
    // label 内の色名テキスト
    var label = t.closest('label.swatch-anchor') || (t.matches && t.matches('label.swatch-anchor') ? t : null);
    if (label) {
      var span = label.querySelector('.attr-title-hover');
      if (span && span.textContent) return span.textContent;
      var forId = label.getAttribute('for');
      if (forId) {
        var byFor = document.getElementById(forId);
        if (byFor && byFor.value) return byFor.value;
      }
    }
    return null;
  }

  function handle(e, useHover) {
    var t = e.target;
    if (!t || !t.closest) return;
    // Globo スワッチの範囲内か
    if (!t.closest('.swatches-globo')) return;
    var color = colorFromTarget(t);
    if (!color) return;
    var mediaEl = mediaElOf(t);
    if (!mediaEl) return;
    if (useHover) {
      applyColor(mediaEl, color);
    } else {
      // クリック/選択は Globo 側の処理より後に確定させる
      window.setTimeout(function () { applyColor(mediaEl, color); }, 0);
    }
  }

  // 初期表示：Liquid が出した初期色に合わせる
  function initCards(scope) {
    (scope || document).querySelectorAll(DATA_SEL).forEach(function (mediaEl) {
      if (mediaEl._ccmInit) return;
      mediaEl._ccmInit = true;
      var initial = mediaEl.getAttribute('data-card-initial-color');
      if (initial) applyColor(mediaEl, initial);
    });
  }

  function init() {
    initCards(document);

    // Globo のスワッチ操作に連動（document への委譲で非同期注入にも対応）
    document.addEventListener('change', function (e) { handle(e, false); }, true);
    document.addEventListener('click', function (e) { handle(e, false); }, true);
    document.addEventListener('mouseover', function (e) { handle(e, true); });

    // カルーセルの追加読み込み等で後から入るカードにも初期色を適用
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () { initCards(document); });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  // 手動テスト/診断用フック（DevTools から実行できる）
  //   CardColorMedia.loaded            → 読み込み確認
  //   CardColorMedia.maps()            → 各カードの color→画像 マップ
  //   CardColorMedia.test('black', 0)  → n番目のカードを指定色に切替
  window.CardColorMedia = {
    loaded: true,
    apply: applyColor,
    init: initCards,
    maps: function () {
      return Array.prototype.map.call(document.querySelectorAll(DATA_SEL), function (el) {
        return { initial: el.getAttribute('data-card-initial-color'), map: readMap(el) };
      });
    },
    test: function (color, idx) {
      var el = document.querySelectorAll(DATA_SEL)[idx || 0];
      if (el) applyColor(el, color);
      return el;
    },
  };

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
